var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5998C0 2.6098 0.81 1.7998 1.8 1.7998H15.3C15.5387 1.7998 15.7676 1.89463 15.9364 2.06341C16.1052 2.23219 16.2 2.46111 16.2 2.6998V3.5998H1.8V4.4998H17.1C17.3387 4.4998 17.5676 4.59463 17.7364 4.76341C17.9052 4.93219 18 5.16111 18 5.3998V14.3998C18 14.8772 17.8104 15.335 17.4728 15.6726C17.1352 16.0102 16.6774 16.1998 16.2 16.1998H1.8C1.32261 16.1998 0.864773 16.0102 0.527208 15.6726C0.189642 15.335 0 14.8772 0 14.3998V3.5998ZM14.85 11.6998C15.208 11.6998 15.5514 11.5576 15.8046 11.3044C16.0578 11.0512 16.2 10.7078 16.2 10.3498C16.2 9.99176 16.0578 9.64838 15.8046 9.39521C15.5514 9.14204 15.208 8.9998 14.85 8.9998C14.492 8.9998 14.1486 9.14204 13.8954 9.39521C13.6422 9.64838 13.5 9.99176 13.5 10.3498C13.5 10.7078 13.6422 11.0512 13.8954 11.3044C14.1486 11.5576 14.492 11.6998 14.85 11.6998Z",
    fill: "#009BDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.94191f108661c272541d2bd241cfd0a5.svg";
export { ForwardRef as ReactComponent };